export default __webpack_public_path__ + "static/media/1967.add4ee84.png";